import { render, staticRenderFns } from "./equipment-fields-db.component.vue?vue&type=template&id=0625618a"
import script from "./equipment-fields-db.component.ts?vue&type=script&lang=ts&external"
export * from "./equipment-fields-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports